module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-body"
  }, [_c('div', {
    staticClass: "alert-message hide-popup",
    class: [_vm.getMessageObj.type, _vm.getMessageObj.customClass]
  }, [_c('div', {
    staticClass: "alert-icon"
  }, [(_vm.getMessageObj.type === 'error') ? _c('i', {
    staticClass: "icon fa fa-ban"
  }) : (_vm.getMessageObj.type === 'warning') ? _c('i', {
    staticClass: "icon fa fa-warning"
  }) : (_vm.getMessageObj.type === 'success') ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-message",
    attrs: {
      "v-bind": _vm.autoClose()
    }
  }, [_vm._v(_vm._s(_vm.titleMessage) + " " + _vm._s(_vm.message) + "\n      "), (_vm.getMessageObj.type === 'error') ? _c('span', {
    staticClass: "yammer-url"
  }, [_vm._v(", "), _c('a', {
    attrs: {
      "href": _vm.yammerErrorUrl
    }
  }, [_vm._v("Please click here to connect with yammer.")])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5a32348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/alert.vue
// module id = 1013
// module chunks = 1